// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type QuizAggregateResultsQueryVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  interval?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.TimeInterval>;
  groupIds?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.Scalars['PositiveInt']> | PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type QuizAggregateResultsQuery = (
  { __typename?: 'Query' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { lastTopicVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & LastTopicVersionFragmentFragment
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
    & { lastTopicVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & LastTopicVersionFragmentFragment
    )> }
  )> }
);

export type LastTopicVersionFragmentFragment = (
  { __typename?: 'TopicVersionModelAsEditor' }
  & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id' | 'number_quizzes'>
  & { publishedQuizzes?: PrivateSchemaTypes.Maybe<Array<(
    { __typename?: 'TopicElementModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicElementModelAsEditor, 'id' | 'data' | 'type'>
    & { freeTextResponses: Array<(
      { __typename?: 'ResponseModelAsEditor' }
      & Pick<PrivateSchemaTypes.ResponseModelAsEditor, 'id' | 'freeQuizResponse'>
      & { enrolment: (
        { __typename?: 'TopicEnrolmentModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsEditor, 'user_id'>
      ) }
    )>, responsesBreakdown?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'ResponsesBreakdownStats' }
      & Pick<PrivateSchemaTypes.ResponsesBreakdownStats, 'correct' | 'incorrect'>
    )>, options: Array<(
      { __typename?: 'QuizOptionModelAsEditor' }
      & Pick<PrivateSchemaTypes.QuizOptionModelAsEditor, 'id' | 'content'>
      & { response_is_correct: PrivateSchemaTypes.QuizOptionModelAsEditor['is_correct'] }
      & { clickRate?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'QuizOptionClickRateAnalytic' }
        & Pick<PrivateSchemaTypes.QuizOptionClickRateAnalytic, 'clicks' | 'totalResponses'>
      )> }
    )> }
  )>> }
);

export const LastTopicVersionFragmentFragmentDoc = gql`
    fragment lastTopicVersionFragment on TopicVersionModelAsEditor {
  id
  number_quizzes
  publishedQuizzes {
    id
    data
    freeTextResponses(interval: $interval, groupIds: $groupIds) {
      id
      freeQuizResponse
      enrolment {
        user_id
      }
    }
    type
    responsesBreakdown(interval: $interval, groupIds: $groupIds) {
      correct
      incorrect
    }
    options: quizOptions {
      response_is_correct: is_correct
      id
      content
      clickRate(interval: $interval, groupIds: $groupIds) {
        clicks
        totalResponses
      }
    }
  }
}
    `;
export const QuizAggregateResultsDocument = gql`
    query quizAggregateResults($topicId: PositiveInt!, $interval: TimeInterval, $groupIds: [PositiveInt!]) {
  topic(id: $topicId) {
    id
    ... on TopicModelAsMember {
      lastTopicVersion {
        ...lastTopicVersionFragment
      }
    }
    ... on TopicModelAsEditor {
      lastTopicVersion {
        ...lastTopicVersionFragment
      }
    }
  }
}
    ${LastTopicVersionFragmentFragmentDoc}`;

/**
 * __useQuizAggregateResultsQuery__
 *
 * To run a query within a React component, call `useQuizAggregateResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizAggregateResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizAggregateResultsQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      interval: // value for 'interval'
 *      groupIds: // value for 'groupIds'
 *   },
 * });
 */
export function useQuizAggregateResultsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QuizAggregateResultsQuery, QuizAggregateResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QuizAggregateResultsQuery, QuizAggregateResultsQueryVariables>(QuizAggregateResultsDocument, options);
      }
export function useQuizAggregateResultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QuizAggregateResultsQuery, QuizAggregateResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QuizAggregateResultsQuery, QuizAggregateResultsQueryVariables>(QuizAggregateResultsDocument, options);
        }
export type QuizAggregateResultsQueryHookResult = ReturnType<typeof useQuizAggregateResultsQuery>;
export type QuizAggregateResultsLazyQueryHookResult = ReturnType<typeof useQuizAggregateResultsLazyQuery>;
export type QuizAggregateResultsQueryResult = Apollo.QueryResult<QuizAggregateResultsQuery, QuizAggregateResultsQueryVariables>;